import React from 'react';
import Wrapper from './RadioInputStyled';

const RadioInput = ({ onFocus, onBlur, onChange, checked, name, title }) => {
    return (
        <Wrapper className="container">
            <input
                type="radio"
                name={name}
                checked={checked}
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={onChange}
            />
            <span className="checkmark"></span>
            {title}
        </Wrapper>
    );
}

export default RadioInput;